import ApiService from './api.service';

export default function ContactFormService() {}

ContactFormService.create = (formData) => {
  return ApiService.post(`/contact_forms`, { contact_form: formData});
}
